<div class="mainContainer  {{navigationPage ? 'customNavigation': ''}}">
    <div class="overlay"></div>
    <div class="sidePanel" *ngIf="!navigationPage">
        <div class="logoSec">
            <a href="#" class="logo"><span class="logoImg"><img src="assets/img/logo.png" alt=""></span><span
                    class="logoText"><img src="assets/img/logoText.png" alt=""></span></a>
        </div>
        <ul class="menu">
            <li [ngClass]="isEnableTab(1) ? '' : 'disable'" class="closepanel" [routerLink]="['company-details']" routerLinkActive="active">
                <a href="#"><span class="menuText">Step 1 - Company Details</span></a>
            </li>
            <ng-container *ngIf="!newAccount">
                    <li [ngClass]="isEnableTab(2) ? '' : 'disable'" class="closepanel" [routerLink]="['add-users']"
                        routerLinkActive="active">
                        <a href="#"><span class="menuText">Step 2 - Add
                                Users</span></a>
                    </li>
                    <li [ngClass]="isEnableTab(3) ? '' : 'disable'" class="closepanel" [routerLink]="['manage']" routerLinkActive="active">
                        <a href="#"><span class="menuText">Step 3 -
                                Manage</span></a>
                    </li>
                    <li [ngClass]="isEnableTab(4) ? '' : 'disable'" class="closepanel" [routerLink]="['app-demo']"
                        routerLinkActive="active">
                        <a href="#"><span class="menuText">Step 4 - App
                                Demo</span></a>
                    </li>
                    <li [ngClass]="isEnableTab(5) ? '' : 'disable'" class="closepanel" [routerLink]="['all-set']" routerLinkActive="active">
                        <a href="#"><span class="menuText">Step 5 - All
                                Set</span></a>
                    </li>
            </ng-container>
        </ul>
        <ul class="helpSec">
            <li class="profile">
                <a href="#">
                    <span class="icon">
                        <img *ngIf="!profilePic" src="assets/img/default.jpg" alt="">
                        <img *ngIf="profilePic" src="{{imageViewUrl}}{{profilePic}}" alt="">
        
                    </span>
                    <span class="text">{{userName | slice:0:11}}
                        <span *ngIf="userName && userName.length >11">...</span>
                    </span>
                        
                    <span class="helpArrow">
                        <i class="material-icons">keyboard_arrow_right</i>
                    </span>
                </a>
                <div class="subNav">
                    <ul class="subNavList">
                      
                        <li (click)="logout();"><a href="#"><i class="material-icons-outlined">power_settings_new</i>Logout</a></li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
  


    <router-outlet></router-outlet>
</div>